import {axiosPrivate} from "../axios-config/axiosPrivate";
import { BACKEND } from "../config/backend"

const convertLog = (log) => ({id: log.id, payload: log.payload, type: log.type, user_id: log.userId, artist_id: log.artistId, created_at: log.createdAt})

export const insertEventLog = (logs) => {
    const dbLogs = logs.map(log => convertLog(log))
    return axiosPrivate.post(`${BACKEND}/api/v1/eventlog`, dbLogs)
}